export const CourseListingText = {
    complete: {
        en: "Complete",
        mr: "पूर्ण झाले",
    },
    LearningMaterials: {
        en: "Learning Materials",
        mr: "शिकण्याचे साहित्य"
    },
    LearningContent: {
        en: "Learning Content",
        mr: "शिकण्याची सामग्री"
    },
    Assignment: {
        en: "Assignment",
        mr: "असाइनमेंट"
    },
    Assessment: {
        en: "Assessment",
        mr: "मूल्यांकन"
    },
    Certification: {
        en: "Certification",
        mr: "प्रमाणपत्र"
    }
};
